import React from 'react';

// This component is now just a stub that renders nothing
// since we no longer need theme switching functionality
export function ThemeToggle() {
  return null;
}